export const ORG_ACTIONS = {
    GENERAL_REQUIRENMENTS : 'GENERAL_REQUIRENMENTS',
    SITE_REQUIRENMENTS : 'SITE_REQUIRENMENTS'
}